import { clone, flow, getRoot, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import { allOptionCode } from "../../components/project/documentobjective/ProjectTypeDropdownList";
import { IInput } from "../../utils/common-interface";
import customtypes from "../../utils/mobx-types-helper";
import fiveYearPlanAPI from "../5yearplan/FiveYearPlanService";
import { IProjectModel, ProjectModel, ResolutionModel } from "../project/ProjectModel";
import { ILoanPeriodsModel, ILoanSourcesModel, LoanPeriodsModel } from "../share/LoanModel";
import { PaginationModel } from "../share/PagingModel";
import { LoanSourcesModel } from "../share/LoanModel";
import { LOVGroupModel } from "../org/OrganizeModel";
export const FiveYearPlanItem = types
    .model("FiveYearPlanItem", {
        planProjecID: customtypes.optional(types.number, 0),
        planID: customtypes.optional(types.number, 0),
        projectID: customtypes.optional(types.number, 0),
        projectDetail: types.optional(ProjectModel, {}),
        loanByYears: types.optional(types.array(LoanPeriodsModel), []),
        loanPeriods: types.optional(types.array(LoanPeriodsModel), []),
        sourceLoanGroup: types.optional(types.array(LoanSourcesModel), []),
        error: customtypes.optional(ErrorModel, {}),
        coordinatorName: customtypes.optional(types.string, ""),
        coordinatorPosition: customtypes.optional(types.string, ""),
        coordinatorTel: customtypes.optional(types.string, ""),
        coordinatorEmail: customtypes.optional(types.string, ""),
        resolutions: customtypes.optional(types.array(ResolutionModel), []),
        files: customtypes.optional(types.array(ResolutionModel), []),
        workingGroupOpinion: customtypes.optional(types.string, ""),
        nesdcApprovalStatus: types.maybeNull(types.boolean), // 1=เห็นชอบ, 0=ไม่เห็นชอบ
        nesdcOfficialOpinion: customtypes.optional(types.string, ""),
        nesdcRecommendation: customtypes.optional(types.string, ""),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        modifyLoanSources: flow(function*() {
            try {
                // self.loanPeriods.forEach((loanPeriod: ILoanPeriodsModel) => {
                //     if (!loanPeriod.domesticLoanSource.currency) {
                //         loanPeriod.domesticLoanSource.setField({
                //             fieldname: "currency",
                //             value: "THB",
                //         });
                //     }

                // });
                console.log("modifyLoanSources", self.loanPeriods);
                const result = yield fiveYearPlanAPI.modifyLoanSources(
                    self.planID,
                    self.projectID,
                    {
                        workingGroupOpinion: self.workingGroupOpinion,
                        nesdcApprovalStatus: self.nesdcApprovalStatus,
                        nesdcOfficialOpinion: self.nesdcOfficialOpinion,
                        nesdcRecommendation: self.nesdcRecommendation,
                        loanPeriods: self.loanPeriods,
                        coordinatorName: self.coordinatorName ,
                        coordinatorPosition: self.coordinatorPosition ,
                        coordinatorTel: self.coordinatorTel ,
                        coordinatorEmail: self.coordinatorEmail ,
                        resolutions: self.resolutions,
                        files: self.files,
                    });
            } catch (e) {
                self.setError(e);
                throw e;
            } finally {
                //
            }
        }),
        setError: (e: any) => {
            self.error.tigger = true;
            self.error.code = e.code;
            self.error.title = e.name;
            self.error.message = e.message;
            self.error.technicalStack = e.technicalStack;
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
            
        },
        onAddResolution: () => {
            self.resolutions.push(ResolutionModel.create({
                no: self.resolutions.length + 1,
                file: null // ResolutionFileModel.create({})
            }));
        }, 
        onRemoveResolution: (index: number) => {
            self.resolutions.splice(index, 1);
        },     
        onAddFile: () => {
            self.files.push(ResolutionModel.create({
                no: self.files.length + 1,
                date: '2021-1-1',
                amount: 0,
                file: null 
            }));
        }, 
        onRemoveFile: (index: number) => {
            self.files.splice(index, 1);
        },                   
    }));
export type IFiveYearPlanItem = typeof FiveYearPlanItem.Type;

// กำหนดประเภทข้อมูลสำหรับโครงสร้างที่ใช้งาน
interface YearItemType {
  periodValue: number;
  loanSources?: Array<{
    sourceType?: string;
    thbAmount?: number;
    loanAmount?: number;
    currency?: string;
    sourceLoan?: {
      code?: string;
    }
  }>;
}

interface ProjectType {
  projectTypeLabel?: string;
  loanByYears?: YearItemType[];
}

interface YearDataType {
  year: string;
  "ในประเทศ": number;
  "ต่างประเทศ": number;
  "รายได้": number;
  "งบประมาณ": number;
  "กองทุน": number;
  "PPP": number;
  "อื่นๆ": number;
  [key: string]: string | number; // เพื่อรองรับการเพิ่ม property อื่นๆ
}
export const FiveYearPlanBodyModel = types
    .model("FiveYearPlanBodyModel", {
        list: types.optional(types.array(FiveYearPlanItem), []),
        startYear: types.maybeNull(types.number),
        projectType: types.optional(types.string, allOptionCode),
        projectTypeLabel: types.maybe(types.string),
        selectedProjectId: types.maybe(types.number),
        paging: types.optional(PaginationModel, {}),
        error: customtypes.optional(ErrorModel, {}),
        loading: types.optional(types.boolean, false),
        lovSourceLoans: types.optional(LOVGroupModel,{}),
        selectedProjectIdArray: types.optional(types.array(types.number), []),
        projectTypeForArray: types.optional(types.string, allOptionCode),
        projectTypeLabelForArray: types.maybe(types.string),

    })
    .views((self: any) => ({
        get chartData() {
            // ไม่มีข้อมูลให้ return array ว่าง
            if (!self.list || !self.list.length) {
                return [];
            }

            const yearData: { [year: string]: YearDataType } = {}; // เก็บข้อมูลรายปี

            // วนลูปผ่านข้อมูลแต่ละโครงการใน list
            self.list.forEach((project: ProjectType) => {
                if (project.loanByYears && project.loanByYears.length) {
                // วนลูปผ่านข้อมูลแต่ละปีของโครงการ
                project.loanByYears.forEach(yearItem => {
                    // ดึงปีและแปลงเป็นปี พ.ศ.
                    const year = yearItem.periodValue.toString();
                    
                    // สร้างหรือเตรียมข้อมูลสำหรับปีนั้นๆ ถ้ายังไม่มี
                    if (!yearData[year]) {
                    yearData[year] = {
                        year,
                        "ในประเทศ": 0,
                        "ต่างประเทศ": 0,
                        "รายได้": 0,
                        "งบประมาณ": 0,
                        "กองทุน": 0,
                        "PPP": 0,
                        "อื่นๆ": 0,
                    };
                    }

                    // วนลูปผ่านแต่ละแหล่งเงินกู้
                    if (yearItem.loanSources && yearItem.loanSources.length) {
                    yearItem.loanSources.forEach(source => {
                        // จัดการกับแหล่งเงินกู้ต่างๆ
                         
                        // ตรวจสอบ sourceLoan เพื่อระบุประเภทแหล่งเงินทุนอื่นๆ
                        if (source.sourceLoan) {
                            const sourceCode = source.sourceLoan.code;
                            
                            // จับคู่รหัสแหล่งเงินทุนกับชื่อ (ปรับตามรหัสจริงของระบบคุณ)
                            if (sourceCode === "01") {
                            yearData[year]["ในประเทศ"] += (source.thbAmount! / 1000000) || 0;
                            } else if (sourceCode === "02") {
                            yearData[year]["ต่างประเทศ"] += (source.thbAmount! / 1000000) || 0;
                            }
                            else if (sourceCode === "03") {
                            yearData[year]["รายได้"] += (source.thbAmount! / 1000000) || 0;
                            } else if (sourceCode === "04") {
                            yearData[year]["งบประมาณ"] += (source.thbAmount! / 1000000) || 0;
                            } else if (sourceCode === "05") {
                            yearData[year]["กองทุน"] += (source.thbAmount! / 1000000) || 0;
                            } else if (sourceCode === "06") {
                            yearData[year]["PPP"] += (source.thbAmount! / 1000000) || 0;
                            } else {
                            yearData[year]["อื่นๆ"] += (source.thbAmount! / 1000000) || 0;
                            }
                        } else {
                            yearData[year]["อื่นๆ"] += (source.thbAmount! / 1000000) || 0;
                        }
                        
                    });
                    }
                });
                }
            });

            // แปลงจาก object เป็น array และเรียงตามปี
            return Object.values(yearData).sort((a, b) => {
                // เรียงตามปี
                return parseInt(a.year) - parseInt(b.year);
            });
        },

    // สำหรับ summary ตามประเภทโครงการ
    // get chartDataByProjectType() {
    //   // ไม่มีข้อมูลให้ return array ว่าง
    //   if (!this.list || !this.list.length) {
    //     return [];
    //   }

    //   const projectTypeData = {}; // เก็บข้อมูลรายประเภทโครงการ

    //   // วนลูปผ่านข้อมูลแต่ละโครงการใน list
    //   this.list.forEach(project => {
    //     // ดึงประเภทโครงการ
    //     const projectType = project.projectTypeLabel || "ไม่ระบุประเภท";
        
    //     // สร้างหรือเตรียมข้อมูลสำหรับประเภทโครงการนั้นๆ ถ้ายังไม่มี
    //     if (!projectTypeData[projectType]) {
    //       projectTypeData[projectType] = {
    //         name: projectType,
    //         "ในประเทศ": 0,
    //         "ต่างประเทศ": 0,
    //         "รวม": 0,
    //       };
    //     }

    //     // วนลูปผ่านข้อมูลแต่ละปีของโครงการ
    //     if (project.loanByYears && project.loanByYears.length) {
    //       project.loanByYears.forEach(yearItem => {
    //         // วนลูปผ่านแต่ละแหล่งเงินกู้
    //         if (yearItem.loanSources && yearItem.loanSources.length) {
    //           yearItem.loanSources.forEach(source => {
    //             // จัดการกับแหล่งเงินกู้ต่างๆ
    //             if (source.sourceType === "L") {
    //               projectTypeData[projectType]["ในประเทศ"] += source.thbAmount || 0;
    //             } else if (source.sourceType === "F") {
    //               projectTypeData[projectType]["ต่างประเทศ"] += source.thbAmount || 0;
    //             }
                
    //             // เพิ่มยอดรวมทุกแหล่งเงิน
    //             projectTypeData[projectType]["รวม"] += source.thbAmount || 0;
    //           });
    //         }
    //       });
    //     }
    //   });

    //   // แปลงจาก object เป็น array
    //   return Object.values(projectTypeData);
    // },

    // สำหรับข้อมูลแยกตามปีและสกุลเงิน
    // get loanByYearAndCurrency() {
    //   // ไม่มีข้อมูลให้ return array ว่าง
    //   if (!this.list || !this.list.length) {
    //     return [];
    //   }

    //   const yearCurrencyData = {}; // เก็บข้อมูลรายปีแยกตามสกุลเงิน

    //   // วนลูปผ่านข้อมูลแต่ละโครงการใน list
    //   this.list.forEach(project => {
    //     if (project.loanByYears && project.loanByYears.length) {
    //       // วนลูปผ่านข้อมูลแต่ละปีของโครงการ
    //       project.loanByYears.forEach(yearItem => {
    //         // ดึงปีและแปลงเป็นปี พ.ศ.
    //         const year = yearItem.periodValue.toString();
            
    //         // สร้างหรือเตรียมข้อมูลสำหรับปีนั้นๆ ถ้ายังไม่มี
    //         if (!yearCurrencyData[year]) {
    //           yearCurrencyData[year] = {
    //             year,
    //             currencies: {},
    //           };
    //         }

    //         // วนลูปผ่านแต่ละแหล่งเงินกู้
    //         if (yearItem.loanSources && yearItem.loanSources.length) {
    //           yearItem.loanSources.forEach(source => {
    //             const currency = source.currency || 'THB';
                
    //             // สร้างหรือเตรียมข้อมูลสำหรับสกุลเงินนั้นๆ ถ้ายังไม่มี
    //             if (!yearCurrencyData[year].currencies[currency]) {
    //               yearCurrencyData[year].currencies[currency] = 0;
    //             }
                
    //             // เพิ่มยอดเงินตามสกุลเงิน (ใช้ loanAmount แทน thbAmount เพื่อเก็บค่าตามสกุลเงินนั้นๆ)
    //             yearCurrencyData[year].currencies[currency] += source.loanAmount || 0;
    //           });
    //         }
    //       });
    //     }
    //   });

    //   // แปลงจาก object เป็น array ที่เหมาะกับการใช้กับ recharts
    //   const result = [];
    
    //   Object.entries(yearCurrencyData).forEach(([year, data]) => {
    //     const entry = { year };
        
    //     // เพิ่มข้อมูลแต่ละสกุลเงิน
    //     Object.entries(data.currencies).forEach(([currency, amount]) => {
    //       entry[currency] = amount;
    //     });
        
    //     result.push(entry);
    //   });
    
    //   // เรียงตามปี
    //   return result.sort((a, b) => parseInt(a.year) - parseInt(b.year));
    // }
    }))
    .actions((self: any) => ({
        getFiveYearPlanBody: flow(function*() {
            try {
                self.loading = true;
                const rootedPlanModel: any = getRoot(self);
                const result = yield fiveYearPlanAPI.getFiveYearPlanBody({
                    startYear: self.startYear,
                    planID: rootedPlanModel.planId,
                    projectType: self.projectType === allOptionCode ? null : self.projectType,
                    paging: self.paging,
                });
                self.lovSourceLoans!.setGroupCode("SOURCELOAN");
                self.lovSourceLoans!.getLOVByGroup();
                self.list = result.data;
                self.setLoanPeriodsYears();
                self.setPagination(result);
                // console.log("k")
                // console.log(self.list);
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                self.loading = false;
            }
        }),
        addProjectToPlan: flow(function*() {
            try {
                const rootedPlanModel: any = getRoot(self);
                if (rootedPlanModel.planId && self.selectedProjectId && self.projectType) {
                    const result = yield fiveYearPlanAPI.addProjectToPlan(
                        rootedPlanModel.planId,
                        self.selectedProjectId,
                        {
                            projType: self.projectType,
                        },
                    );
                }
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
        addProjectToPlanList: flow(function*() {
            try {
                const rootedPlanModel: any = getRoot(self);
                if (rootedPlanModel.planId && self.selectedProjectIdArray && self.projectTypeForArray) {
                    const result = yield fiveYearPlanAPI.addProjectToPlanList(
                        rootedPlanModel.planId,
                        {
                            projType: self.projectTypeForArray,
                            ProjIds: self.selectedProjectIdArray,
                        },
                    );
                }
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
        removeProjectFromPlan: flow(function*(removingProjectId: number) {
            try {
                const rootedPlanModel: any = getRoot(self);
                if (rootedPlanModel.planId && removingProjectId && self.projectType) {
                    const result = yield fiveYearPlanAPI.removeProjectFromPlan(
                        rootedPlanModel.planId,
                        removingProjectId,
                        {
                            projType: self.projectType,
                        },
                    );
                }
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
        setLoanPeriodsYears: () => {
            self.list.forEach((fiveYearPlanItem: IFiveYearPlanItem) => {
                fiveYearPlanItem.loanByYears.forEach((loanByYear: ILoanPeriodsModel) => {
                    loanByYear.loanSources.forEach((loanSource: ILoanSourcesModel) => {
                        if (loanSource.sourceType === "F" && !loanSource.currency) {
                            loanSource.setField({
                                fieldname: "currency",
                                value: "USD",
                            });

                        }
                        if (loanSource.sourceType === "L" && !loanSource.currency) {
                            loanSource.setField({
                                fieldname: "currency",
                                value: "THB",
                            });
                        }
                       
                        let item = fiveYearPlanItem.sourceLoanGroup.find(i => i.currency ==  loanSource.currency && i.sourceLoan.id == loanSource.sourceLoan.id);
                        if (!item) {
                            fiveYearPlanItem.sourceLoanGroup.push({currency: loanSource.currency, 
                                sourceLoan:{
                                    id: loanSource.sourceLoan.id,
                                    code: loanSource.sourceLoan.code,
                                    description:loanSource.sourceLoan.description}})
                        }
                        
                    });
                    fiveYearPlanItem.loanPeriods.push(loanByYear.loanPeriodsJSON);
                    fiveYearPlanItem.sourceLoanGroup = fiveYearPlanItem.sourceLoanGroup.sort((a,b) => a.sourceLoan.code > b.sourceLoan.code ? 1 : -1 );
                     
                });
                
            });
        
             
        },
        setField: ({ fieldname, value }: IInput) => {
            self[fieldname] = value;
        },
        onSelectedProject: (selectedProjectId?: number) => {
            self.selectedProjectId = selectedProjectId;
        },
        onSelectedFilter: (projectTypeLabel: string, projectType: string) => {
            self.setDefaultPagination();
            self.projectType = projectType;
            self.projectTypeLabel = projectTypeLabel;
            self.getFiveYearPlanBody();
        },
        onSearchTextFilter: (value: any) => {
            self.setDefaultPagination();
            self.paging.searchText = value;
            self.getFiveYearPlanBody();
        },
        setPagination: (result: any) => {
            self.paging.pageSize = result.pageSize;
            self.paging.pageNo = result.pageNo;
            self.paging.totalRow = result.totalRow;
        },
        onSelectedPage: (pageNo: number) => {
            self.paging.pageNo = pageNo;
            self.getFiveYearPlanBody();
        },
        setDefaultPagination: () => {
            self.paging.pageNo = 1;
        },
        resetAll: () => {
            self.list = [];
            self.paging = {};
        },
        // ฟังก์ชันสำหรับจัดการ Array
        addSelectedProjectId: (projectId: number) => {
            if (!self.selectedProjectIdArray.includes(projectId)) {
            self.selectedProjectIdArray.push(projectId);
            }
        },
        removeSelectedProjectId: (projectId: number) => {
            const index = self.selectedProjectIdArray.indexOf(projectId);
            if (index > -1) {
            self.selectedProjectIdArray.splice(index, 1);
            }
        },
        clearSelectedProjectIdArray: () => {
            self.selectedProjectIdArray = [];
        },
    }));

export type IFiveYearPlanBodyModel = typeof FiveYearPlanBodyModel.Type;
